import { weekStartDate } from '../helper';

/* The OneDrive delivery workbook "New Delivery.xlsx" (user, 2026-10-28), shown in
 * Finance → Delivery Sheet. Nothing is downloaded or stored: the browser shows Microsoft's own
 * embedded viewer.
 *
 * EMBED_BASE is the address from OneDrive's File → Share → Embed code (the plain share link can't
 * be embedded). EMBED_OPTIONS are the options of the user's latest embed code, used AS-IS (user,
 * 2026-10-28): typing allowed (in the viewer only, never saved to OneDrive), download button shown,
 * gridlines and headings shown. The system adds only:
 *   ActiveCell='<tab>'!A1      opens that tab. `Item=` only accepts named ranges and errors on a
 *                              tab name; ActiveCell opens the tab and keeps the tab bar.
 *   _                          cache-buster, so Sync gets OneDrive's latest saved version
 * To change the options, generate a new embed code and copy its query string here.
 */
export const EMBED_BASE = 'https://1drv.ms/x/c/ba64331a8245fe32/IQQy_kWCGjNkIIC6Aw4AAAAAAe45vk4Kag79-JzEj81IHxE';

/* The week's tab: its Monday as ddmmyy, e.g. 2026-W41 → Mon 5 Oct 2026 → "051026". */
export function sheetTabName(weekCode) {
    const monday = weekStartDate(weekCode);          // 'YYYY-MM-DD'
    if (!monday) return '';
    const [y, m, d] = monday.split('-');
    return `${d}${m}${y.slice(2)}`;
}

export const EMBED_OPTIONS = 'em=2&wdAllowInteractivity=False&AllowTyping=True&wdDownloadButton=True&wdInConfigurator=True&wdInConfigurator=True';

export function sheetEmbedUrl(weekCode, bust = Date.now()) {
    const params = new URLSearchParams(EMBED_OPTIONS);
    const tab = sheetTabName(weekCode);
    if (tab) params.set('ActiveCell', `'${tab}'!A1`);
    params.set('_', String(bust));
    return `${EMBED_BASE}?${params.toString()}`;
}
